import { CheckoutStyles } from "@omni/ui/brand/checkout/checkout.styles";
import { Button } from "@omni/ui/components/Button/button.component";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type SubmitPaymentButtonComponentProps = {
    loading: boolean;
};

const SubmitPaymentButtonComponent = ({
    loading
}: SubmitPaymentButtonComponentProps) => {
    const { t } = useGranite();

    return (
        <Button
            type={"submit"}
            color={CheckoutStyles.submitButton?.color || "success"}
            loading={loading}
        >
            {t("checkout.psp.paymentMethods.submit.label")}
        </Button>
    );
};

export { SubmitPaymentButtonComponent };
